export const UPDATE_ORDER_SETTINGS_SUCCESS = "redux_store:orders.success.update_settings";

export const ADD_ORDER_SHIFT_SUCCESS = "redux_store:orders.success.add_shift";
export const DELETE_ORDER_SHIFT_SUCCESS = "redux_store:orders.success.delete_shift";
export const UPDATE_ORDER_SHIFT_SUCCESS = "redux_store:orders.success.update_shift";

export const ADD_ORDER_PRODUCT_SUCCESS = "redux_store:orders.success.add_product";
export const DELETE_ORDER_PRODUCT_SUCCESS = "redux_store:orders.success.delete_product";
export const UPDATE_ORDER_PRODUCT_SUCCESS = "redux_store:orders.success.update_product";

export const UPDATE_ORDER_SUCCESS = "redux_store:orders.success.update";

export const ACTIVATE_STRIPE_SUCCESS = "redux_store:orders.success.activate_stripe";
export const DEACTIVATE_STRIPE_SUCCESS = "redux_store:orders.success.deactivate_stripe";



// WEBPACK FOOTER //
// ./src/successes/orders.js